import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import rangesReducer from "./rangesSlice";
import tableReducer from "./tableSlice";

export const store = configureStore({
  reducer: {
    ranges: rangesReducer,
    table: tableReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
